import styled from "styled-components";
import { IMember } from "./teamMembers";

const TeamMemberWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  max-width: 240px;
  transition: all 0.3s ease-in-out;
  img {
    width: 238px;
    height: 280px;
    object-fit: contain;
    margin: 0 auto;

    @media ${({ theme }) => theme.mediaQueries.bellowTabletPortrait} {
      width: 135px;
    }
  }

  .multiline-ellipsis {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  h6 {
    font-size: 30px;
    font-weight: 700;
    margin: 15px 0;
    color: #fff;
  }

  span {
    display: block;
    font-family: Neue-Haas, sans-serif;
    font-weight: 400;
    font-size: 15px;
    margin-bottom: 10px;
    color: #cecfd0;
  }

  p {
    font-family: Neue-Haas, sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #cecfd0;
  }

  &.fellow:hover {
    cursor: pointer;
    transform: scale(1.05);
  }

  @media ${({ theme }) => theme.mediaQueries.bellowTabletPortrait} {
    h6 {
      font-size: 20px;
      line-height: 33px;
      margin-bottom: 4px;
    }
    span {
      size: 14px;
    }
  }
`;

interface TeamMemberProps {
  member: IMember;
  onClick?: () => void;
}

const TeamMember: React.FC<TeamMemberProps> = ({ member, onClick }) => {
  return (
    <TeamMemberWrapper onClick={onClick}>
      <img src={member.img.src} alt={member.img.alt} />
      <h6>{member.name}</h6>
      <span>{member.position}</span>
      {!!member.bio && <p className="multiline-ellipsis">{member.bio}</p>}
    </TeamMemberWrapper>
  );
};

export default TeamMember;
